import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useBrand } from '../../../../brands/contexts/BrandContext';
import './BudzdorovAuthError.scss';

const BudzdorovAuthError: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { brand } = useBrand();

  // Получаем сообщение об ошибке из query параметров или используем дефолтное
  const searchParams = new URLSearchParams(location.search);
  const errorMessage = searchParams.get('error') || 'Произошла ошибка при авторизации через BudZdorov API';

  // Получаем путь к логотипу из конфигурации бренда
  const getAuthLogo = () => {
    return `${process.env.PUBLIC_URL}/${brand.logos.auth}`;
  };

  const handleRetry = () => {
    // Пытаемся получить userId и protocolId из query параметров
    const userId = searchParams.get('userId');
    const protocolId = searchParams.get('protocolId');
    
    if (userId && protocolId) {
      // Перенаправляем обратно с теми же параметрами для повторной попытки
      navigate(`/?userId=${userId}&protocolId=${protocolId}`, { replace: true });
    } else {
      // Если параметров нет, просто обновляем страницу
      window.location.reload();
    }
  };

  return (
    <div className="budzdorov-auth-error-page">
      <div className="auth-error-container">
        <div className="auth-error-header">
          <img 
            src={getAuthLogo()} 
            alt={brand.name} 
            className="auth-error-logo"
          />
        </div>

        <div className="auth-error-content">
          <div className="auth-error-icon">
            <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="12" cy="12" r="10" />
              <line x1="12" y1="8" x2="12" y2="12" />
              <line x1="12" y1="16" x2="12.01" y2="16" />
            </svg>
          </div>

          <h1 className="auth-error-title">Ошибка авторизации</h1>
          
          <p className="auth-error-message">{errorMessage}</p>

          <div className="auth-error-actions">
            <button
              className="button-primary"
              onClick={handleRetry}
            >
              Попробовать снова
            </button>
          </div>

          <div className="auth-error-help">
            <p>Если проблема сохраняется, обратитесь в службу поддержки.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BudzdorovAuthError;
